import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthRepository, UserRole } from '../auth/auth.repository';

@Injectable({
  providedIn: 'root'
})
export class AdminNavigationService {
  private _showAdminSidebar = new BehaviorSubject<boolean>(false);
  private _adminRoles = [
    UserRole.SuperUser,
    UserRole.SysAdmin,
    UserRole.CourseAdmin,
    UserRole.Advisor,
    UserRole.Supervisor,
    UserRole.Translator
  ];

  constructor(private authRepository: AuthRepository) {
    this.updateSidebarVisibility();
  }

  get showAdminSidebar$(): Observable<boolean> {
    return this._showAdminSidebar.asObservable();
  }

  get showAdminSidebar(): boolean {
    return this._showAdminSidebar.value;
  }

  updateSidebarVisibility(): void {
    const user = this.authRepository.getUser();
    if (!user) {
      this._showAdminSidebar.next(false);
      return;
    }

    const hasAdminRole = this._adminRoles.includes(user.role);
    this._showAdminSidebar.next(hasAdminRole);
  }

  hasAdminRole(): boolean {
    const user = this.authRepository.getUser();
    if (!user) return false;
    
    return this._adminRoles.includes(user.role);
  }

  /** Returns true only for SuperUser and SysAdmin. */
  isSuperOrSysAdmin(): boolean {
    const user = this.authRepository.getUser();
    if (!user) return false;
    return user.role === UserRole.SuperUser || user.role === UserRole.SysAdmin;
  }

  getAdminRoleName(role: UserRole): string {
    switch (role) {
      case UserRole.SuperUser:
        return 'Super User';
      case UserRole.SysAdmin:
        return 'System Admin';
      case UserRole.CourseAdmin:
        return 'Course Admin';
      case UserRole.Advisor:
        return 'Advisor';
      case UserRole.Supervisor:
        return 'Supervisor';
      case UserRole.Translator:
        return 'Translator';
      default:
        return 'Unknown';
    }
  }
} 